export default __webpack_public_path__ + "static/media/MasterCard.9717a7a1.svg";